/* esm.sh - esbuild bundle(@internetarchive/donation-form-section@0.3.6) esnext production */
import{__decorate as a}from"/v135/tslib@2.8.1/esnext/tslib.mjs";import{LitElement as u,html as s,css as e}from"/v135/lit@2.8.0/esnext/lit.mjs";import{customElement as B,property as d}from"/v135/lit@2.8.0/esnext/decorators.js";var i;(function(n){n.HideBadge="hidebadge",n.ShowBadge="showbadge",n.HideBadgeLeaveSpacing="hidebadgeleavespacing"})(i||(i={}));var o=class extends u{constructor(){super(...arguments),this.sectionBadge="0",this.badgeMode=i.ShowBadge}render(){return s`
      <div class="container ${this.badgeMode}">
        <div class="badge-container">
          <div class="badge">${this.sectionBadge}</div>
        </div>
        <div class="content-container">
          ${this.headline?s` <div class="title">${this.headline}</div> `:""}
          <div class="content">
            <slot></slot>
          </div>
        </div>
      </div>
    `}static get styles(){let g=e`var(--formSectionBadgeTransition, 0.25s ease-out)`,c=e`var(--formSectionBadgeMargin, 1rem)`,l=e`var(--formSectionBadgeBackgroundColor, #333)`,r=e`var(--formSectionBadgeRadius, 1.2rem)`,t=e`calc(${r} * 2)`,m=e`var(--formSectionBadgeFontSize, 1.8rem)`,h=e`var(--formSectionBadgeFontWeight, bold)`,v=e`var(--formSectionBadgeFontColor, #fff)`,b=e`var(--formSectionTitleFontSize, 1.8rem)`,p=e`var(--formSectionTitleFontWeight, bold)`,f=e`var(--formSectionContentBackgroundColor, transparent)`,S=e`var(--formSectionTextColor, #333)`,$=e`calc(${r} * 2)`;return e`
      :host {
        display: block;
        background-color: ${f};
        color: ${S};
      }
      .container {
        position: relative;
        padding: 0.5rem;
      }

      .content-container {
        position: relative;
        left: calc(${t} + ${c});
        width: calc(100% - (${t} + ${c}));
        transition: ${g};
        z-index: 1;
      }

      .hidebadge .content-container {
        left: 0;
        width: 100%;
      }

      .hidebadge .badge-container {
        display: none;
      }

      .hidebadgeleavespacing .badge {
        display: none;
      }

      .badge-container {
        position: absolute;
        width: ${t};
      }

      .badge {
        background-color: ${l};
        color: ${v};
        width: ${t};
        height: ${t};
        border-radius: ${r};
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: ${h};
        font-size: ${m};
      }

      .title {
        line-height: ${$};
        margin-bottom: 0.5rem;
        font-size: ${b};
        font-weight: ${p};
      }
    `}};a([d({type:String})],o.prototype,"sectionBadge",void 0);a([d({type:String})],o.prototype,"headline",void 0);a([d({type:String})],o.prototype,"badgeMode",void 0);o=a([B("donation-form-section")],o);export{o as DonationFormSection,i as DonationFormSectionBadgeMode};
//# sourceMappingURL=donation-form-section.mjs.map